(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/utils/api-wager.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/utils/api-wager.js');

'use strict';

class Wager {
  constructor(_ref) {
    let {
      wagerModel,
      day
    } = _ref;
    this.wagerModel = wagerModel;
    this.day = day;
    const returnObj = {
      bets: this.bets
    };
    if (this.wagerModel.get('isPackage') && this.wagerModel.bagTypeIdMap) {
      const selectedPackage = this.wagerModel.get('selectedPackage');
      if (day) {
        const dayString = svs.numbergames.productMapping.getDay(day);
        returnObj.bagType = this.wagerModel.bagTypeIdMap["".concat(selectedPackage, " ").concat(dayString)];
      } else {
        returnObj.bagType = this.wagerModel.bagTypeIdMap[selectedPackage];
      }
    }
    if (this.wagerModel.get('isSyndicate')) {
      returnObj.syndicate = this.wagerModel.get('isSyndicate');
      returnObj.syndicateId = this.wagerModel.get('syndicateId');
    }
    return returnObj;
  }
  get bets() {
    const Bet = svs.numbergames.game_model.utils.API_Bet;
    const JokerBet = svs.numbergames.game_model.utils.API_JokerBet;
    const bets = [new Bet({
      wagerModel: this.wagerModel,
      day: this.day
    })];
    if (this.wagerModel.get('hasJoker')) {
      bets.push(new JokerBet({
        wagerModel: this.wagerModel,
        day: this.day
      }));
    }
    return bets;
  }
}
svs.numbergames.game_model.utils.API_Wager = Wager;

 })(window);